import { useState } from "react";
import { useLocation } from "react-router-dom";
import "./nav.css";
import logo from "../../../assets/img/logo.png";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleLinkClick = (e, anchor) => {
    setOpen(false);

    // Si on est sur la page mentions légales, rediriger vers la page d'accueil avec l'ancre
    if (location.pathname.includes("mentions-legales")) {
      e.preventDefault();
      window.location.href = `/${anchor}`;
    }
    // Sinon, laisser le comportement par défaut (scroll vers l'ancre)
  };

  return (
    <nav className="Nav">
      <a href="/">
        <img src={logo} alt="Logo" className="nav__logo" />
      </a>

      <button
        className={`burger ${open ? "open" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={`nav__links ${open ? "open" : ""}`}>
        <li>
          <a href="/#accueil" onClick={(e) => handleLinkClick(e, "#accueil")}>
            Accueil
          </a>
        </li>
        <li>
          <a href="/#about" onClick={(e) => handleLinkClick(e, "#about")}>
            À propos
          </a>
        </li>
        <li>
          <a href="/#team" onClick={(e) => handleLinkClick(e, "#team")}>
            Équipe
          </a>
        </li>
        <li>
          <a href="/#services" onClick={(e) => handleLinkClick(e, "#services")}>
            Services
          </a>
        </li>
        <li>
          <a
            href="/#realisation"
            onClick={(e) => handleLinkClick(e, "#realisation")}
          >
            Galerie
          </a>
        </li>
        <li>
          <a href="/#contact" onClick={(e) => handleLinkClick(e, "#contact")}>
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
}
